"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagementPeriodStatus = void 0;
var ManagementPeriodStatus;
(function (ManagementPeriodStatus) {
    ManagementPeriodStatus["UPCOMING"] = "UPCOMING";
    ManagementPeriodStatus["ACTIVE"] = "ACTIVE";
    ManagementPeriodStatus["DONE"] = "DONE";
    ManagementPeriodStatus["CANCELED"] = "CANCELED";
})(ManagementPeriodStatus = exports.ManagementPeriodStatus || (exports.ManagementPeriodStatus = {}));
//# sourceMappingURL=HlManagementPeriod.js.map